import React from "react";
import ContactForm from '../components/ContactForm';
import HeaderSpacer from '../components/HeaderSpacer';
import styled from 'styled-components';
import {heights, colours} from '../Styles';
import gtr from '../img/gtr.jpg';

function Contact() {
  const {contactBar} = heights;
  const { light } = colours;
  const Contact = styled.div`
    height: calc(100vh - ${contactBar});
    background: ${light};
    h2 {
      color: ${light};
    }
    .form-wrap {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: url(${gtr});
      background-size: cover;
      background-position: center;
    }
  `;
  return (
    <Contact>
      <HeaderSpacer/>
      <div className="form-wrap">
      <h2>Get in touch</h2>
        <ContactForm/>
      </div>
    </Contact>
  );
}

export default Contact;
